import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["src"];
import React from 'react';
import { Grid } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import { DEFAULT_OVERLAY_CLASS_NAME, DEFAULT_TILE_CLASS_NAME } from './DynamicTile.constants';
import { groupElementsByTypeInOrder, sortElementsByOrder, createComponentsFromGroupedElements, getImage } from './DynamicTile.utils';
import Image from '../../../../../../atoms/Image';
import { classNames } from '../../../../../../utils/classname';
import VideoPlayer from '../../../../../video/components/VideoPlayer/VideoPlayer';
import { DynamicTilePropTypes } from '../../../../types/DynamicTile';
import './DynamicTile.less';
var defaultProps = {
  images: [],
  video: null,
  content: [],
  interactions: [],
  width: 16,
  overlayClassName: '',
  className: '',
  imageProps: {}
};
function DynamicTile(_ref) {
  var _classNames, _classNames2;
  var images = _ref.images,
    video = _ref.video,
    content = _ref.content,
    interactions = _ref.interactions,
    width = _ref.width,
    overlayClassName = _ref.overlayClassName,
    className = _ref.className,
    imageProps = _ref.imageProps;
  var finalClassName = classNames((_classNames = {}, _defineProperty(_classNames, DEFAULT_TILE_CLASS_NAME, true), _defineProperty(_classNames, className, className), _classNames));
  var finalImageClassName = classNames((_classNames2 = {}, _defineProperty(_classNames2, DEFAULT_OVERLAY_CLASS_NAME, true), _defineProperty(_classNames2, overlayClassName, overlayClassName), _classNames2));
  var sortedElements = sortElementsByOrder([].concat(_toConsumableArray(content), _toConsumableArray(interactions)));
  var groupedElements = groupElementsByTypeInOrder(sortedElements);
  var finalContent = createComponentsFromGroupedElements(groupedElements);
  var image = getImage(images);
  var src = image.src,
    restImage = _objectWithoutProperties(image, _excluded);
  function getSingleImageContent() {
    return /*#__PURE__*/React.createElement(Image, _extends({}, restImage, {
      className: finalImageClassName,
      src: src,
      background: true
    }, imageProps || {}), finalContent);
  }
  function getVideoContent() {
    var url = video.url,
      videoId = video.videoId,
      source = video.source,
      placeholder = video.placeholder;
    return /*#__PURE__*/React.createElement(VideoPlayer, {
      url: url,
      videoId: videoId,
      source: source,
      placeholder: placeholder
    });
  }
  function getContent() {
    if (!_isEmpty(video)) {
      return getVideoContent();
    }
    return getSingleImageContent();
  }
  return /*#__PURE__*/React.createElement(Grid.Column, {
    className: finalClassName,
    width: width || 16
  }, getContent());
}
DynamicTile.defaultProps = defaultProps;
export default DynamicTile;